// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3fn1Z","empty":"ModalGraph_empty__1O8zA"};